export default __webpack_public_path__ + "static/media/45.8a6e3b69.png";